
import React, { useEffect, useReducer, useState } from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DatePicker from "../../../General/DatePicker"
import CalendaRangeInput from '../../../General/CalendarRangeInput';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { saveAs } from "file-saver";
import { enumUtil } from "../../../../utils/Enum";
import { ServerRequestProtected, ServerRequestPublic } from "../../../../utils/ServerDataRequest";
import { useSelector } from "react-redux";
import GridColumnHeader from "../../../Setup/Shared/GridColumnHeader";
import Table from "../../../Setup/Shared/Table";
import Loader from "../../../shared/Loader/Loader";
import FormValidator from "../../../../utils/FormValidator";
import NotificationHandler from "../../../../utils/NotificationHandler";
import { format } from "date-fns";
import isNull from "../../../../utils/NullChecking";
import AmountFormatter from "../../../../utils/AmountFormatter";
import { FindFirstChild } from '../../../../utils/FindMenuOption'
import AdvancePayment from "./AdvancePayment";
import CellExpanderFormatter from "../../../Billing/Claims/ClaimDetails/CellExpandFormatter";
import ReactDataGrid from 'react-data-grid';
import { Modal } from "react-bootstrap";
import AddPatientCard from "./AddPatientCard";
import PrintStatementGenrate from "../../../Billing/Statements/StatementsDetails/Print Statements/PrintstementGenrate";
import HandleStatus from "../../../shared/HandleStatus";
import PatientPayments from "../../../shared/PatientPayments/PatientPayments";


const PaymentDetailColumns = [
    { key: 'PaymentType', name: 'Payment Type' },
    { key: 'ClaimID', name: 'Claim ID' },
    { key: 'DOS', name: 'DOS', width: 170 },
    { key: 'CPT', name: 'CPT' },
    {
        key: 'PostedAmount', name: 'Posted Amount', renderCell: ({ row }) => {
            return <AmountFormatter amount={row.PostedAmount} />;
        },
    },
    { key: 'PostedDate', name: 'Posted Date', width: 150 },
    { key: 'PostedBy', name: 'Posted By', width: 150 },
];
let SubGridData = [];
let SubGridDataFilter = {}

const PatientPaymentsPat = (props) => {
    let Base_URL = process.env.REACT_APP_FURL
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id;
    let IsEditAllowed = FindFirstChild('Patient', 'Payments')?.IsAdd
    let Statement_Modal = {
        PatientID: "",
        MinimumAccountBalance: "",
        DunningMessage_0_30: "",
        DunningMessage_31_60: "",
        DunningMessage_61_90: "",
        DunningMessage_Over90: "",
        DaysAfterFirstStatement: "",
        NumberOfPatientStatementsSent: ""
    }
    let Credit_Modal = {
        CollectedAmount: "",
        CreditCard: '',
        Last4Digit: '',
        Comments: '',
        PaymentMethod: '',
    }
    let Cheque_Modal = {
        CollectedAmount: "",
        Check: '',
        CheckAmount: '',
        Comments: '',
        PaymentMethod: '',
    }
    let Other_Modal = {
        CollectedAmount: "",
        OtherPaymentMethod: '',
        Comments: '',
        PaymentMethod: '',
    }
    let Cash_Modal = {
        CollectedAmount: "",
        Comments: '',
        PaymentMethod: '',
    }
    let PatientCredit_Modal = {
        PatientCredit: "",
        Comments: '',
        PaymentMethod: '',
    }
    let Payment_Modal = {
        // CollectedAmount: "",
        CollectedDate: null,
        Comments: "",
        PaymentMethod: "",
        PaymentType: "",
        Last4Digit: "",
        CreditCard: ""
    }
    let validation = {
        CollectedAmount: '',
        CollectedDate: '',
    }
    let valModal = {}

    const Search_Data = {
        // "PatientIDs": null,
        // "ClaimNo": null,
        "DOSFrom": null,
        "DOSTo": null,
        // "EntryDateFrom": null,
        // "EntryDateTo": null,
        // "SubmittedFrom": null,
        // "SubmittedTo": null,
        // "PaymentFrom": null,
        // "PaymentTo": null,
        "PostedFrom": null,
        "PostedTo": null,
        // "ProviderID": "-1",
        // "LocationID": "-1",
        // "ReferringProviderID": "-1",
        // "SupervisingProviderID": "-1",
        // "ProcedureCode": null,
        // "PayerClaimNo": null,
        // "ClaimStatus": "-1",
        // 'Submitted': '-1',
        // 'Paid': '-1',

        // "BillingStatus": null,
        // "PaymentStatus": null,
        // "InsuranceID": "-1",
        // "CreatedBy": "-1",
    }

    const Search_Data_Statement = {
        "StatementFrom": null,
        "StatementTo": null,
        "StatementNo": '',
        ProviderID: "",
        LocationID: "",
    }
    const [paymentValidation, setPaymentValidation] = useState(validation);
    const [mainPaymentModal, setMainPaymentModal] = useState(Payment_Modal);
    const [mainCredit, setmainCredit] = useState(Credit_Modal);
    const [mainCheque, setmainCheque] = useState(Cheque_Modal);
    const [mainOther, setmainOther] = useState(Other_Modal);
    const [mainCash, setmainCash] = useState(Cash_Modal);
    const [mainPatientCredit, setmainPatientCredit] = useState(PatientCredit_Modal);
    const [DateCollected, setDateCollected] = useState(null)
    const [paymentMethod, setPaymentMethod] = useState('-1');
    const [CollectedAmount, setCollectedAmount] = useState('');
    const [CopayDue, setCopayDue] = useState('');
    const [saveUpdatedcash, setsaveUpdatedcash] = useState({})
    const [saveUpdatedCash, setsaveUpdatedCash] = useState({})
    const [saveUpdatedChque, setsaveUpdatedCheque] = useState({})
    const [savePaymentModal, setSavePaymentModal] = useState({});
    const [saveUpdatedCredit, setsaveUpdatedCredit] = useState({})
    const [saveUpdatedOther, setsaveUpdatedOther] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [documentData, setDocumentData] = useState([])
    const [tranSummary, settranSummary] = useState()
    const [historyData, setHistoryData] = useState([])
    const [searchParam, setSearchParam] = useState(Search_Data)
    const [searchParamStatement, setSearchParamStatement] = useState(Search_Data_Statement)
    const API_URL = enumUtil.controller.PatientPayment
    const [mainStatementModal, setmainStatementModal] = useState(Statement_Modal);
    const [StatementSaveUpdateModal, setStatementSaveUpdateModal] = useState({})
    const [PatientStatementID, setPatientStatementID] = useState();
    const [patientPaymentSummary, setPatietPaymentSummary] = useState({});
    const API_ExcelExport = enumUtil.controller.ExcelExport;
    const [isOpenCardDetail, setIsOpenCardDetail] = useState(false)
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' });

    let paymentFormValidation = async () => {
        let validation = {
            CollectedAmount: FormValidator(CollectedAmount, enumUtil.enumValidationType.Required, "Collected Amount"),
            CollectedDate: FormValidator(DateCollected, enumUtil.enumValidationType.Required, "Collected Date"),
            CreditCardVal: paymentMethod === "Credit"
                ? FormValidator(mainCredit.CreditCard, enumUtil.enumValidationType.Required, "Credit Card Details")
                : null,
            Last4DigitVal: paymentMethod === "Credit"
                ? FormValidator(mainCredit.Last4Digit, enumUtil.enumValidationType.Required, "Last 4 Digit")
                : null,

            CheckVal: paymentMethod === "Check"
                ? FormValidator(mainCheque.Check, enumUtil.enumValidationType.Required, "Check #")
                : null,
            CheckAmountVal: paymentMethod === "Check"
                ? FormValidator(mainCheque.CheckAmount, enumUtil.enumValidationType.Required, "Check Amount")
                : null,

            CheckAmountVal: paymentMethod === "Check"
                ? FormValidator(mainCheque.CheckAmount, enumUtil.enumValidationType.Required, "Check Amount")
                : null,
            PaymenMethodVal: FormValidator(mainPaymentModal.PaymentMethod, enumUtil.enumValidationType.Required, "Payment Method"),
        };

        setPaymentValidation(validation);

        // Assuming valModal is used for external purposes
        valModal = validation; // Ensure this is declared if used elsewhere
    };
    const handleStatementChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainStatementModal };
        let saveModal = { ...StatementSaveUpdateModal }
        modal[name] = value
        setmainStatementModal(modal)
        for (var property in Statement_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setStatementSaveUpdateModal(saveModal)
    }
    const handleSaveStatement = async () => {
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            let saveModal = {
                TableName: enumUtil.enumAPITableName.PATIENTSTATEMENTSETUP,
                ID: PateintIDR,
                data: { ...StatementSaveUpdateModal },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SavePatientStatementSetting", 'post', saveModal)
                .then((response) => {
                    setIsLoading(false)
                    if (!isNull(response.id)) {
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        setPatientStatementID(response.id)
                        // setOnInsuranceCSave(true)
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    const getPatientStatementHistory = () => {
        setIsLoading(true);
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.PrintStatementsLogs,
            "SEARCHCRITERIA": {
                "PatientIDs": PateintIDR + '',
                ...searchParamStatement
            },
            "PERPAGE": 100,
            "PAGENO": 1,
        }
        ServerRequestProtected(API_URL + '/GetStatemenHistory', 'post', saveModal).then((response) => {
            setIsLoading(false);
            handleGridHeader({ defaultData: response.Rows })
            setHistoryData(response.Rows);
        }).catch((error) => {
            setIsLoading(false);
            setHistoryData([]);
        })
    }
    const getPatientPaymentSummary = () => {
        setIsLoading(true);
        let saveModal = {
            "TableName": "PATIENTSTATEMENTSETUP",
            "ID": PateintIDR + '',
        }
        ServerRequestProtected(API_URL + '/GetPatientPaymentSummary', 'post', saveModal).then((response) => {
            setIsLoading(false);
            setPatietPaymentSummary(...response);
        }).catch((error) => {
            setIsLoading(false);
        })
    }
    const [isOpenPrint, setIsOpenPrint] = useState(false)
    const [selectedClaimId, setSelectedClaimID] = useState([]);

    const closeGenrate = () => {
        setIsOpenPrint(false)
    }
    const [isOpenPatientPayment, setisPatientPayment] = useState(false)
    const [PatientID, setPatientID] = useState(); //
    const [PrintStatementsLogsID, setPrintStatementsLogsID] = useState()
    const [StatementNumber, setStatementNumber] = useState()

    const AddPatPayment = (id, statementid, StmnttNumber) => {
        setisPatientPayment(true)
        setPatientID(id)
        setPrintStatementsLogsID(statementid)
        setStatementNumber(StmnttNumber + "")
    }
    const OnClosePtPayment = (type) => {
        setisPatientPayment(false)
        setPatientID()
        setPrintStatementsLogsID()
        if (type === 'PtPayment') {
            getPatientStatementHistory()
        }
    }
    let PtPaymentPopup = '';
    if (isOpenPatientPayment) {
        PtPaymentPopup = <PatientPayments isOpenPatientPayments={isOpenPatientPayment} OnClosePtPayment={OnClosePtPayment} PatientID={PatientID} type={'Claim'} ID={''} LoadClaimData={() => { }} AdvancePayment={null} PrintStatementsLogsID={PrintStatementsLogsID} StatementNumber={StatementNumber} />
    }
    const handleGenerate = (Id) => {
        setIsOpenPrint(true)
        setSelectedClaimID(Id)
    }
    let BASE_URL = process.env.REACT_APP_FURL
    const handleView = (item) => {
        if (!isNull(item?.PatientPaymentsID)) {
            window.open(
                `${BASE_URL}#/ViewPaidReceipt/${item.PatientPaymentsID}`,
                // `https://portal.theeasyedi.com/#/ViewPaidReceipt/${PaymentsID}`,
                //  `http://localhost:3000/#/ViewPaidReceipt/${item.CommonValue}`,
                "_blank",
                "noopener,noreferrer"
            );
        }
    }
    const handleOpenPayLink = (StatementNumber) => {
        // const url = `http://localhost:3000/#/Pay/${StatementNumber}`;
        const url = `${Base_URL}#/Pay/${StatementNumber}`;
        window.open(url, '_blank');
    };
    let popup = ''

    if (isOpenPrint) {
        popup = <PrintStatementGenrate isOpen={isOpenPrint} onClose={closeGenrate} ID={selectedClaimId} Genrate={'View'} Type={'History'} />
    }
    const bottomSummaryRows = documentData?.length > 0 ? [tranSummary] : [];

    const columns = [
        {
            key: 'expanded',
            name: '',
            minWidth: 30,
            width: 30,
            colSpan(args) {
                return args.type === 'ROW' && args.row.type === 'DETAIL' ? 8 : undefined;
            },
            cellClass(row) {
                return row.type === 'DETAIL'
                    ?
                    " padding: 24px;"

                    : undefined;
            },
            renderCell({ row, isCellSelected, onRowChange, tabIndex }) {
                if (row.type === 'DETAIL') {
                    return (
                        <DetailedGrid
                            isCellSelected={isCellSelected}
                            parentId={row.parentId}
                            row={row} />
                    );
                }
                return (
                    <CellExpanderFormatter
                        expanded={row.expanded}
                        isCellSelected={isCellSelected}
                        onCellExpand={() => {
                            onRowChange(Object.assign(Object.assign({}, row), { expanded: !row.expanded }));
                        }}
                        tabIndex={tabIndex}
                    />
                );
            }
        },
        {
            key: 'CollectedDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Collected Date'} sortIcon={true} type={'date'} colKey={'CollectedDate'} data={documentData} setData={setDocumentData} />),
            resizable: true,
        },
        {
            key: 'CollectedAmount',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Collected Amount'} sortIcon={true} type={'date'} colKey={'CollectedAmount'} data={documentData} setData={setDocumentData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return <AmountFormatter amount={row.CollectedAmount} />;
            },
            renderSummaryCell: () => {
                return (
                    <AmountFormatter amount={tranSummary?.CollectedAmount} />)
            }
        },
        {
            key: 'PaymentMethod',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Payment Method'} sortIcon={true} type={'string'} colKey={'PaymentMethod'} data={documentData} setData={setDocumentData} />),
            resizable: true,
        },
        {
            key: 'Description',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Description'} sortIcon={true} type={'string'} colKey={'Description'} data={documentData} setData={setDocumentData} />),
            resizable: true,
        },
        {
            key: 'AppliedAmount',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Applied Amount'} sortIcon={true} type={'number'} colKey={'AppliedAmount'} data={documentData} setData={setDocumentData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return <AmountFormatter amount={row.AppliedAmount} />;
            },
            renderSummaryCell: () => {
                return (
                    <AmountFormatter amount={tranSummary?.AppliedAmount} />)
            }
        },
        {
            key: 'UnAppliedAmount',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'UnApplied Amount'} sortIcon={true} type={'number'} colKey={'UnAppliedAmount'} data={documentData} setData={setDocumentData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return <AmountFormatter amount={row.UnAppliedAmount} />;
            },
            renderSummaryCell: () => {
                return (
                    <AmountFormatter amount={tranSummary?.UnAppliedAmount} />)
            }
        },
        {
            key: 'PostedBy',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Posted By'} sortIcon={true} type={'string'} colKey={'PostedBy'} data={documentData} setData={setDocumentData} />),
            resizable: true,
        },
    ]
    const Historycolumns = [
        {
            key: 'StatementNumber',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Statement #'} sortIcon={true} type={'string'} colKey={'StatementNumber'} data={historyData} setData={setHistoryData} />),
            resizable: true,
            width: 200,

            renderCell: ({ row }) => {
                return (
                    <div className="d-flex align-items-center justify-content-between gap-10 w-100">
                        <p className='text'>{row?.StatementNumber}</p>
                        <p className='pill Denied E-Statemnt-Status'>E-Statement</p>
                        {/* Denied */}
                    </div>
                )
            },
        },
        {
            key: 'PatientBalance',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Amount'} sortIcon={true} type={'number'} colKey={'PatientBalance'} data={historyData} setData={setHistoryData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (<AmountFormatter amount={row.PatientBalance} />);
            },
        },
        {
            key: 'PaidAmount',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Paid'} sortIcon={true} type={'string'} colKey={'PaidAmount'} data={historyData} setData={setHistoryData} />),
            resizable: true,
            width: 120,
            renderCell: ({ row }) => {
                return (<AmountFormatter amount={row.PaidAmount} />);
            },
        },
        {
            key: 'StatementDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Statement Date'} sortIcon={true} type={'string'} colKey={'StatementDate'} data={historyData} setData={setHistoryData} />),
            resizable: true,
            width: 200,
        },

        // {
        //     key: 'LineItemsNo',
        //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        //         iconName={''} headerName={'List Items#'} sortIcon={true} type={'string'} colKey={'LineItemsNo'} data={historyData} setData={setHistoryData} />),
        //     resizable: true,
        // },
        // {
        //     key: 'StatementType',
        //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        //         iconName={''} headerName={'Statement Type'} sortIcon={true} type={'string'} colKey={'StatementType'} data={historyData} setData={setHistoryData} />),
        //     resizable: true,
        //     width: 120,
        // },
        {
            key: 'StatementBy',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Generated By'} sortIcon={true} type={'string'} colKey={'StatementBy'} data={historyData} setData={setHistoryData} />),
            resizable: true,
            width: 200,
        },
        {
            key: 'StatementDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Generated Date'} sortIcon={true} type={'string'} colKey={'StatementDate'} data={historyData} setData={setHistoryData} />),
            resizable: true,
            width: 200,
        },
        {
            key: 'StatementStatus',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Status'} sortIcon={false} type={''} colKey={'StatementStatus'} data={historyData} setData={setHistoryData} />),
            renderCell: ({ row }) => {
                return <HandleStatus Status={row?.StatementStatus} />
            },
        },
        {
            key: 'Actions',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Action'} sortIcon={false} type={''} colKey={'Action'} data={historyData} setData={setHistoryData} />),
            renderCell: ({ row }) => {
                return (
                    <>
                        {row.StatementStatus === 'Pending' ?
                            <div className="d-flex gap-6 align-itemes-center w-100 ar-action-data">
                                <p className='text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer lh-12' onClick={() => handleGenerate(row?.PrintStatementsLogsID)}>View</p>
                                <p className='text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer lh-12' onClick={() => AddPatPayment(row.PatientID, row?.PrintStatementsLogsID, row?.StatementNumber)}>Make Payment</p>
                                <p className='text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer lh-12'>Resend Email</p>
                            </div>
                            : row.StatementStatus === 'Partial Paid' ?
                                <div className="d-flex gap-6 align-itemes-center w-100 ar-action-data">
                                    {!isNull(row.PatientPaymentsID) ?
                                        <p className='text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer lh-12' onClick={() => handleView(row)}>Receipt</p>
                                        : null}
                                    <p className='text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer  lh-12' onClick={() => handleGenerate(row?.PrintStatementsLogsID)}>View</p>
                                    <p className='text validate-color br-clr-light  pe-1-5 text-nowrap cursor-pointer br-right-1 pe-1-5 lh-12' onClick={() => AddPatPayment(row.PatientID, row?.PrintStatementsLogsID, row?.StatementNumber)}>Make Payment</p>

                                    <p className='text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer lh-12'>Resend Email</p>
                                </div>
                                : row.StatementStatus === 'Paid' ?
                                    <div className="d-flex gap-6 align-itemes-center w-100 ar-action-data">
                                        <p className='text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer lh-12' onClick={() => handleView(row)}>Receipt</p>
                                        <p className='text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer lh-12' onClick={() => handleGenerate(row?.PrintStatementsLogsID)}>View</p>

                                        <p className='text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer lh-12'>Resend Email</p>

                                    </div>
                                    : null}
                        {/* <div className="btnWrapper-col">
                            <>
                                <button
                                    className="border-0 bg-transparent no-width rounded eye app_tooltip bottom"
                                    onClick={() => handleGenerate(row?.PrintStatementsLogsID)}
                                >
                                    <i class="icon-Icon-awesome-eye"></i>
                                    <p class="tool_tip xsm_text text-light">View</p>
                                </button>
                                <button className="btn btn-link p-0" onClick={() => handleOpenPayLink(row.StatementNumber)}>Pay</button>
                            </>
                        </div> */}
                    </>
                );
            }
        },

    ]

    const LoadData = (searchParam) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + '/TransactionByPatientID', 'post', {
            "TableName": enumUtil.enumAPITableName.PATIENTSTATEMENTSETUP,
            "ID": PateintIDR, // PatientID 
            "SearchCriteria": searchParam,
        })
            .then((response) => {
                setIsLoading(false);
                const newRows = response?.Rows.map(row => ({
                    ...row,
                    type: 'MASTER',
                    expanded: false,
                }));
                handleGridHeader({ defaultData: response.Rows })
                setDocumentData(newRows);
                settranSummary(response?.count)
                // SubGridData = response
                handleGridHeader({ defaultData: response })
            }).catch((error) => {
                settranSummary({})
                setDocumentData([]);
                setIsLoading(false);
            })
    }
    const [userAccountDetails, setUserAccountDetails] = useState({})
    const GetAccountDetails = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + '/GetAccountDetails', 'post', {
            "TableName": enumUtil.enumAPITableName.PATIENTACCOUNTDETAILS,
            "ID": PateintIDR, // PatientID 
        })
            .then((response) => {
                setIsLoading(false)
                setUserAccountDetails(response)
            }).catch((error) => {
                setIsLoading(false)
                setUserAccountDetails({})
            })
    }
    const handleDownloadexexl = () => {
        setIsLoading(true);
        ServerRequestPublic(API_ExcelExport + "/ExportExcelList", 'post', {
            "TableName": enumUtil.enumAPITableName.Patient,
            "searchParam": searchParam,
            "PerPage": 100000,
            "PageNo": 1,
        }, "Download",)
            .then((response) => {
                setIsLoading(false);
                let blob = new Blob([response]);
                saveAs(blob, 'Transactions.xlsx');
            }).catch((error) => {
                setIsLoading(false);
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            });
    }
    const handleOnchange = (e) => {
        const { name, value } = e.target;
        setPaymentMethod(value);
        const modal = { ...mainPaymentModal };
        const SaveModal = { ...savePaymentModal };
        modal[name] = value;
        for (var property in Payment_Modal) {
            if (name === property) {
                SaveModal[name] = value
            }
        }
        setMainPaymentModal(modal);
        SaveModal[name] = value;
        // SaveModal['CollectedAmount'] = value; // Add CollectedAmount to SaveModal
        // SaveModal['PaymentMethod'] = value; 
        setSavePaymentModal(SaveModal);
    }
    const handlepatientChnage = (e, type) => {
        const { name, value } = e.target;
        if (type === 'credit') {
            let modal = { ...mainCredit }
            let saveModal = { ...saveUpdatedCredit }
            modal[name] = value
            setmainCredit(modal)
            for (var property in Credit_Modal) {
                if (name === property) {
                    saveModal[name] = value
                }
            }
            setsaveUpdatedCredit(saveModal)
        }
        else if (type === 'Check') {
            let modal = { ...mainCheque }
            let saveModal = { ...saveUpdatedChque }
            modal[name] = value
            setmainCheque(modal)
            for (var property in Cheque_Modal) {
                if (name === property) {
                    saveModal[name] = value
                }
            }
            setsaveUpdatedCheque(saveModal)
        }
        else if (type === 'other') {
            let modal = { ...mainOther }
            let saveModal = { ...saveUpdatedOther }
            modal[name] = value
            setmainOther(modal)
            for (var property in Other_Modal) {
                if (name === property) {
                    saveModal[name] = value
                }
            }
            setsaveUpdatedOther(saveModal)
        }
        else if (type === 'Cash') {
            let modal = { ...mainCash }
            let saveModal = { ...saveUpdatedCash }
            modal[name] = value
            setmainCash(modal)
            for (var property in Cash_Modal) {
                if (name === property) {
                    saveModal[name] = value
                }
            }
            setsaveUpdatedCash(saveModal)
        }
        else if (type === 'PatientCredit') {
            let modal = { ...mainPatientCredit }
            let saveModal = { ...saveUpdatedCash }
            modal[name] = value
            setmainPatientCredit(modal)
            for (var property in PatientCredit_Modal) {
                if (name === property) {
                    saveModal[name] = value
                }
            }
            setsaveUpdatedCash(saveModal)
        }
    }
    const handleAmountChange = (e) => {
        setCollectedAmount(e.target.value)
        // setUnAppliedAAmount(e.target.value)
    }
    const handleCalendarChange = (date, type) => {
        setDateCollected(date)
        // setMainPaymentModal({ ...mainPaymentModal, CollectedDate: date });
        // setSavePaymentModal({ ...savePaymentModal, CollectedDate: date });
    }
    const saveCollectedCopay = async () => {
        await paymentFormValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck);
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return;
        } else {
            setIsLoading(true)
            let SaveModal
            if (paymentMethod === 'Cash') {
                SaveModal = { ...savePaymentModal, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, PaymentMethod: paymentMethod, PatientID: PateintIDR + "" }
            } else if (paymentMethod === 'Check') {
                SaveModal = { ...saveUpdatedChque, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, PaymentMethod: paymentMethod, PatientID: PateintIDR + "" }
            } else if (paymentMethod === 'Credit') {
                SaveModal = { ...saveUpdatedCredit, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, PaymentMethod: paymentMethod, PatientID: PateintIDR + "" }
            } else if (paymentMethod === 'Other') {
                SaveModal = { ...saveUpdatedOther, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, PaymentMethod: paymentMethod, PatientID: PateintIDR + "" }
            } else if (paymentMethod === 'PatientCredit') {
                SaveModal = { ...savePaymentModal, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, PaymentMethod: paymentMethod, PatientID: PateintIDR + "" }
            } else if (paymentMethod === 'PatientCredit') {
                SaveModal = { ...savePaymentModal, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, PaymentMethod: paymentMethod, PatientID: PateintIDR + "" }
            }
            let saveModal = {
                TableName: enumUtil.enumAPITableName.CollectCopay,
                ID: 0,
                data: SaveModal,
                value: null,
            }
            SaveModal['PaymentType'] = 'Advance Payment';
            ServerRequestProtected(API_URL + '/CollectCopay', 'post', saveModal).then((response) => {
                setIsLoading(false)
                NotificationHandler("Record Saved Successfully", enumUtil.enumtoaster.success)
                LoadData()
                onClearAdvancePay()
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }
    const handleProcess = (ID) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/ProcessFile", 'post', {
            // "TableName": enumUtil.enumAPITableName.Files,
            FileID: ID,
            "TemplateID": "1",
        }).then((response) => {
            setIsLoading(false)
            LoadData()
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)

        })
    }
    useEffect(() => {
        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 216) {
                    LoadData();
                    getPatientStatementHistory();
                    getPatientPaymentSummary();
                    GetAccountDetails()
                }
            })
        }
    }, [props.Reload])
    const onClearAdvancePay = () => {
        setCollectedAmount('')
        setDateCollected(null)
        setMainPaymentModal(Payment_Modal)
        setmainCredit(Credit_Modal)
        setmainCheque(Cheque_Modal)
        setmainOther(Other_Modal)
        setmainCash(Cash_Modal)
    }
    const [isOpenAdvancePayment, setIsOpenAdvancePayment] = useState(false)
    const OnCloseAdvancePayment = (type) => {
        if (type === 'AdvancePayment') {
            LoadData()
            getPatientPaymentSummary()
        }
        setIsOpenAdvancePayment(false)
    }
    const OpenAdvancePayment = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpenAdvancePayment(true)
    }
    let advancePaymentPopup
    if (isOpenAdvancePayment) {
        advancePaymentPopup = <AdvancePayment
            isOpenCopay={isOpenAdvancePayment}
            OnCloseCopay={OnCloseAdvancePayment}
            DateCollected={DateCollected}
            paymentValidation={paymentValidation}
            PatientID={PateintIDR}
        // handleCalendarChange={handleCalendarChange}
        // CopayDue={CopayDue}
        // setCopayDue={setCopayDue}
        // CollectedAmount = {CollectedAmount}
        // handleAmountChange = {handleAmountChange}
        // saveCollectedCopay = {saveCollectedCopay}
        />
    }

    const handleClearSearch = () => {
        setSearchParam({ ...Search_Data });
    }
    const findRecord = async (ID) => {
        setIsLoading(true);
        try {
            const response = await ServerRequestProtected(API_URL + "/AdvancePaymentSubGrid", 'post', {
                "TableName": enumUtil.enumAPITableName.PATIENTSTATEMENTSETUP,
                "ID": ID,
            });
            setIsLoading(false);
            return response;
        } catch (error) {
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            setIsLoading(false);
            return null; // Return a default value or handle the error case as needed
        }
    }
    const onRowsChange = async (rows, { indexes }) => {
        const row = rows[indexes[0]];
        if (row.type === 'MASTER') {
            if (!row.expanded) {
                rows.splice(indexes[0] + 1, 1);
            }
            else {
                rows.splice(indexes[0] + 1, 0, {
                    type: 'DETAIL',
                    id: row.PatientPaymentsID,
                    parentId: row.PatientPaymentsID
                });
            }
            setDocumentData(rows);
            if (row.expanded) {
                let rowz = await findRecord(row.PatientPaymentsID)
                rowz.forEach((item) => {

                    if (SubGridDataFilter.hasOwnProperty(item.PatientPaymentsID)) {
                        let filteredData = SubGridDataFilter[item.PatientPaymentsID].some((claim) => {
                            return claim.PatientPaymentsAppliedID === item.PatientPaymentsAppliedID;
                        })
                        if (!filteredData) {
                            // Append the current item to the existing array
                            SubGridDataFilter[item.PatientPaymentsID].push(item);
                        }
                    } else {
                        // Create a new array with the current item
                        SubGridDataFilter[item.PatientPaymentsID] = [item];
                    }
                });
            } else {
                if (SubGridDataFilter.hasOwnProperty(row.PatientPaymentsID)) {
                    // Append the current item to the existing array
                    SubGridDataFilter[row.PatientPaymentsID] = [];
                }
            }
            SubGridData = SubGridDataFilter;
            // findRecord(row.AuditDate, AuditDetails)
        }
    }

    const getRowHeight = (row) => {
        if (row.type === 'DETAIL') {
            const count = SubGridDataFilter[row.parentId]?.length || 0;
            const heights = { 1: 56, 2: 81, 3: 106, 4: 131 };

            if (count >= 5) return 156;
            return heights[count] ?? 56;
        }
        return 25;
    };

    let addCard = ''
    const onClosePatientCard = () => {
        GetAccountDetails()
    }
    if (isOpenCardDetail) {
        addCard = <AddPatientCard isOpenCardDetail={isOpenCardDetail} setIsOpenCardDetail={setIsOpenCardDetail} PatientID={PateintIDR} onClose={onClosePatientCard} />
    } else {
        addCard = ''
    }

    const handleSearchStatementHistory = () => {
        getPatientStatementHistory()
    }
    return (
        <>
            <div className="patient_payment_screen_size">
                {advancePaymentPopup}
                {popup}
                {PtPaymentPopup}
                {isLoading ? <Loader /> : null}
                <div className='row m-0 g-0 patients_payments'>
                    <div className="d-flex">
                        <div className="patients_payments_summary w-100">
                            <div className="d-flex justify-content-between align-items-center w-100 pat-header px-10">
                                <p className="heading">Patient Payments Summary</p>
                                <button className="btn btn-orange px-10 rounded" onClick={OpenAdvancePayment}>Add Advance Payment</button>
                            </div>
                            <div className='row py-1 mx-0 g-0 px-10 py-1 row-gap-5 pat-content'>
                                <div className='col-md-4'>
                                    <div className="d-flex align-items-center ">
                                        <div className="col-md-7">
                                            <p className="heading">Total Collected</p>
                                        </div>
                                        <div className="col-md-5">
                                            <p className="text bg_color w-max-content px-2"><AmountFormatter amount={patientPaymentSummary?.TotalCollected} /></p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4 ps-10'>
                                    <div className="d-flex">
                                        <div className="col-md-4">
                                            <p className="heading">Total Applied</p>
                                        </div>
                                        <div className="col-md-8">
                                            <p className="text ar-light-color fs-11"><AmountFormatter amount={patientPaymentSummary?.TotalApplied} /></p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4 ps-10'>
                                    <div className="d-flex">
                                        <div className="col-md-6">
                                            <p className="heading">Total Unapplied</p>
                                        </div>
                                        <div className="col-md-6">
                                            <p className="text ar-light-color fs-11"><AmountFormatter amount={patientPaymentSummary?.TotalUnapplied} /></p>
                                        </div>
                                    </div>
                                </div>
                                <div />
                                <div className='col-md-4'>
                                    <div className="d-flex">
                                        <div className="col-md-7">
                                            <p className="heading">Patient Due</p>
                                        </div>
                                        <div className="col-md-5">
                                            <p className="text ar-light-color fs-11"><AmountFormatter amount={patientPaymentSummary?.PatientDue} /></p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4 ps-10'>
                                    <div className="d-flex ">
                                        <div className="col-md-4">
                                            <p className="heading">Last Payment </p>
                                        </div>
                                        <div className="col-md-8">
                                            <p className="text ar-light-color fs-11">
                                                {patientPaymentSummary?.LastPaymentDate ? patientPaymentSummary?.LastPaymentDate : 'N/A'}
                                                {patientPaymentSummary?.LastPaymentAmount ? <AmountFormatter amount={patientPaymentSummary?.LastPaymentAmount} /> : ''}
                                                <span className="text ar-light-color fs-11">  {patientPaymentSummary?.PaymentEnteredBy ? 'By ' + patientPaymentSummary?.PaymentEnteredBy : ''}</span></p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4 ps-10'>
                                    <div className="d-flex">
                                        <div className="col-md-6">
                                            <p className="heading">Advance Available</p>
                                        </div>
                                        <div className="col-md-6">
                                            <p className="text ar-light-color fs-11"><AmountFormatter amount={patientPaymentSummary?.AdvanceAvailable} /></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="Credit-Card-Info flex-shrink-0">

                            <div className="d-flex justify-content-between align-items-center w-100 card-header pe-4 ps-10">
                                <p className="heading">Credit Card Info</p>
                                {isNull(userAccountDetails?.Cardlast4Digit) ?
                                    <button className="btn btn-orange px-10 rounded" onClick={() => setIsOpenCardDetail(!isOpenCardDetail)}>Add Card</button>
                                    : null}
                            </div>
                            <div className="card-content h-100 px-10 py-1">
                                <div className="d-flex flex-column gap-5">
                                    <p className="text ar-light-color fs-11 font-m lh-22">{userAccountDetails?.Cardlast4Digit ? userAccountDetails?.CardType + '*********' + userAccountDetails?.Cardlast4Digit : 'N/A'}</p>
                                    <div className="d-flex align-items-center gap-2">
                                        <p className="heading w-85px">Exp. Date</p>
                                        <p className="text ar-light-color fs-11 font-m">{userAccountDetails?.Expiry ? userAccountDetails?.Expiry : 'N/A'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <Accordion defaultExpanded>
                        <AccordionSummary
                            aria-hidden='true'
                            id="prac1-header"
                            aria-controls="prac1-content"
                            expandIcon={<ExpandMoreIcon />}
                        >
                            <p className="heading">Add Advance Payment </p>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className='row mb-2'>
                                <div className='col-md-3'>
                                    <DatePicker
                                        label='Date Collected'
                                        name="CollectedDate"
                                        value={DateCollected}
                                        inputError={paymentValidation.CollectedDate}
                                        handleCalendarChangefunc={(date) => { handleCalendarChange(date, 'CollectedDate') }}
                                    />
                                    {paymentValidation.CollectedDate}
                                </div>
                                <div className='col-md-3'>
                                    <div class={paymentValidation.CollectedAmount ? "input error" : "input"}>
                                        <label for="">Collected Amount<span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            variant="outlined"
                                            class="form-control"
                                            autoComplete="off"
                                            name="CollectedAmount"
                                            id="CollectedAmount"
                                            maxlength="55"
                                            value={CollectedAmount}
                                            onChange={handleAmountChange} />
                                    </div>
                                    {paymentValidation.CollectedAmount}
                                </div>
                            </div>

                            <div className='row mb-2'>
                                <div className='col-md-3'>
                                    <div className={paymentValidation.PaymenMethodVal ? "input error" : "input"}>
                                        <label>Payment Method <span style={{ color: 'red' }}>*</span></label>
                                        <select className="form-control fc-xs" id="PaymentMethod" name="PaymentMethod" value={mainPaymentModal.PaymentMethod} onChange={handleOnchange}>
                                            <option value="-1"></option>
                                            <option value="Credit">Credit</option>
                                            <option value="Check">Cheque</option>
                                            <option value="Cash">Cash</option>
                                            <option value="PatientCredit">Patient Credit</option>
                                            <option value="Other">Other</option>
                                        </select>
                                        {paymentValidation.PaymenMethodVal}
                                    </div>
                                </div>
                                {mainPaymentModal.PaymentMethod === "Credit" && (
                                    <div className='col-md-4 d-flex'>
                                        <div>
                                            <div className={paymentValidation.CreditCardVal ? "input error" : "input"}>
                                                <label> Credit Card<span style={{ color: 'red' }}>*</span></label>
                                                <input variant="outlined" autoComplete="off" className="form-control" name="CreditCard" id="CreditCard" maxLength="8" value={mainCredit.CreditCard} onChange={(e) => handlepatientChnage(e, 'credit')} />
                                                {paymentValidation.CreditCardVal}
                                            </div>
                                        </div>
                                        <div>
                                            <div className={paymentValidation.Last4DigitVal ? "input error ps-3" : "input ps-3"}>
                                                <label htmlFor=""> Last 4-Digits of Card<span style={{ color: 'red' }}>*</span></label>
                                                <div className='d-flex'>
                                                    <div className='col-md-6'>
                                                        <label htmlFor=""> XXXX-XXXX-</label>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <input variant="outlined" className="form-control" autoComplete="off" name="Last4Digit" id="Last4Digit" maxLength="4" value={mainCredit.Last4Digit} onChange={(e) => handlepatientChnage(e, 'credit')} />
                                                        {paymentValidation.Last4DigitVal}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className='col-md-10'>
                                                <div class="input ps-3">
                                                    <label for="">Comments</label>
                                                    <input variant="outlined" class="form-control" autoComplete="off" name="Comments" id="Comments" maxlength="55" value={mainCredit.Comments} onChange={(e) => handlepatientChnage(e, 'credit')} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {mainPaymentModal.PaymentMethod === "Check" && (
                                    <div className='col-md-3 d-flex'>
                                        <div>
                                            <div className={paymentValidation.CheckVal ? "input error ps-3" : "input ps-3"}>
                                                <label>Cheque<span style={{ color: 'red' }}>*</span></label>
                                                <div className='d-flex'>
                                                    <div className='col-md-7'>
                                                        <input variant="outlined" className="form-control" autoComplete="off" name="Check" id="Check" maxLength="4" value={mainCheque.Check} onChange={(e) => handlepatientChnage(e, 'Check')} />
                                                        {paymentValidation.CheckVal}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className={paymentValidation.CheckAmountVal ? "input error ps-3" : "input ps-3"}>
                                                <label htmlFor="">Cheque Amt<span style={{ color: 'red' }}>*</span></label>
                                                <div className='d-flex'>
                                                    <div className='col-md-7'>
                                                        <input variant="outlined" className="form-control" autoComplete="off" name="CheckAmount" id="CheckAmount" maxLength="4" value={mainCheque.CheckAmount} onChange={(e) => handlepatientChnage(e, 'Check')} />
                                                        {paymentValidation.CheckAmountVal}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className='col-md-10'>
                                                <div class="input ps-3">
                                                    <label for="">Comments</label>
                                                    <input variant="outlined" class="form-control" autoComplete="off" name="Comments" id="Comments" maxlength="55" value={mainCheque.Comments} onChange={(e) => handlepatientChnage(e, 'Check')} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {mainPaymentModal.PaymentMethod === "Other" && (
                                    <div className='col-md-4 d-flex'>
                                        <div className='col-md-6'>
                                            <div class="input">
                                                <label for="">Other Payment Method</label>
                                                <input variant="outlined" class="form-control" autoComplete="off" name="OtherPaymentMethod" id="OtherPaymentMethod" maxlength="55" value={mainOther.OtherPaymentMethod} onChange={(e) => handlepatientChnage(e, 'other')} />
                                            </div>
                                        </div>
                                        <div>
                                            <div className='col-md-10'>
                                                <div class="input ps-3">
                                                    <label for="">Comments</label>
                                                    <input variant="outlined" class="form-control" autoComplete="off" name="Comments" id="Comments" maxlength="55" value={mainOther.Comments} onChange={(e) => handlepatientChnage(e, 'other')} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {mainPaymentModal.PaymentMethod === "Cash" && (
                                    <div className='col-md-4 d-flex'>
                                        <div className='col-md-6'>
                                            <div class="input">
                                                <label for="">Comments</label>
                                                <input variant="outlined" class="form-control" autoComplete="off" name="Comments" id="Comments" maxlength="55" value={mainCash.Comments} onChange={(e) => handlepatientChnage(e, 'Cash')} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {mainPaymentModal.PaymentMethod === "PatientCredit" && (
                                    <div className='col-md-4 d-flex'>
                                        <div className='col-md-6'>
                                            <div class="input">
                                                <label for="">Comments</label>
                                                <input variant="outlined" class="form-control" autoComplete="off" name="PatientCredit" id="PatientCredit" maxlength="55" value={mainPatientCredit.PatientCredit} onChange={(e) => handlepatientChnage(e, 'PatientCredit')} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className='col-md-5 d-flex align-items-end'>

                                    <div className='col-md-6 ps-3'>
                                        <div className="btns-group-flex claims_btns">
                                            <button className={IsEditAllowed ? "btn btn-orange btn-xs no-width rounded" : "btn btn-orange btn-xs no-width rounded disabled"} onClick={saveCollectedCopay}>Save</button>
                                            <span class="seprate"></span>
                                            <button className="btn btn-outline btn-xs no-width rounded me-1" onClick={() => onClearAdvancePay()}>Clear</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion> */}
                    <div class="hk-payment-tabs ">
                        <div className="hk-inner-tabs">
                            <Tab.Container defaultActiveKey="Transactions">
                                <div className="innerTabs-Header">
                                    <Nav variant="tabs" className='card-tabs'>
                                        <Nav.Item>
                                            <Nav.Link eventKey="Transactions">Transactions</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="StatementSettings">Statement Settings</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="StatementHistory">Statement History</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                                <Tab.Content>
                                    <Tab.Pane eventKey="Transactions">
                                        <div className='row mx-0 align-items-end py-2'>
                                            <div className='col-md-3'>
                                                <CalendaRangeInput searchParam={searchParam} setSearchParam={setSearchParam} options={['DOS', 'Posted']} />
                                            </div>
                                            {/* <div className='col-md-3'>
                                                <div class="input">
                                                    <label for=""> Statement#</label>
                                                    <input variant="outlined" autoComplete="off" className="rounded form-control" name="AddressLine1" id="AddressLine1" maxlength="55" />
                                                </div>
                                            </div> */}
                                            <div className='col-md-4'>
                                                <div className="btns-group-flex claims_btns">
                                                    <button className="btn btn-orange btn-xs no-width rounded" onClick={() => LoadData(searchParam)}>Search</button>
                                                    <span class="seprate"></span>
                                                    <button className="btn btn-outline btn-xs no-width rounded me-1" onClick={handleClearSearch}>Clear</button>
                                                </div>
                                            </div>
                                            <div className="col-md-5 text-end">
                                                <i className="icon-excel validate-color fs-20" onClick={handleDownloadexexl}></i>
                                            </div>
                                        </div>
                                        {/* Patient Payment Table  */}
                                        <div className='row mx-0 align-items-end pt-2 '>
                                            <div className="hk-docFlex__content col-md-12 px-0">
                                                <div className="row hk-docFlex__content__flex m-0">
                                                    <div className="doc-table col-md-12 px-0">
                                                        <ReactDataGrid
                                                            columns={columns}
                                                            rows={documentData}
                                                            className='fill-grid DataGrid-Table hk-exp-table templates serviceline-grid pat-payment-grid blue-header'
                                                            headerRowHeight={25}
                                                            rowHeight={getRowHeight}
                                                            onRowsChange={onRowsChange}
                                                            bottomSummaryRows={bottomSummaryRows} //sticky footer
                                                            style={{
                                                                height: '363px',
                                                                maxHeight: '363px',
                                                            }}

                                                        />
                                                        {/* <Table
                                                            columns={columns}
                                                            rows={documentData}
                                                            height='465px'
                                                            dynamicClass='fill-grid DataGrid-Table hk-exp-table templates serviceline-grid pat-payment-grid'
                                                            rowHeight={25}
                                                            hidePagination={true}
                                                            Key={21}
                                                            Name={'PatientSearch'}
                                                            hideColClass={'hide'}
                                                        /> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="StatementSettings">
                                        <div className="row m-0 py-3">
                                            <div className='col-md-3'>
                                                <div class="input">
                                                    <label for="">Patient  Statement Cycle </label>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <input variant="outlined" class="form-control" name="AddressLine1" id="AddressLine1" maxlength="55" />
                                                        <label for="">Days </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div class="input">
                                                    <label for="">Minimum Account Balance </label>
                                                    <div className="row">
                                                        <div className='col-md-8'>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                name="MinimumAccountBalance"
                                                                id="MinimumAccountBalance"
                                                                value={mainStatementModal.MinimumAccountBalance}
                                                                onChange={handleStatementChange}
                                                                maxlength="55" />
                                                        </div>
                                                        <div className='col-md-4 p-0'>
                                                            <label for="">(in U.S.Dollars)</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row m-0 app_border dunning_message">
                                            <p className="heading">Dunning Messages</p>
                                        </div>
                                        <div className="row m-0 mt-3">
                                            <div className="col-md-6">
                                                <div className="d-flex gap-3 align-items-center">
                                                    <div className="col-md-2">
                                                        <p className="text">Current To 30</p>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="input">
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                id="DunningMessage_0_30"
                                                                name="DunningMessage_0_30"
                                                                value={mainStatementModal.DunningMessage_0_30}
                                                                onChange={handleStatementChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="d-flex align-items-center">
                                                    <div className="col-md-2">
                                                        <p className="text">31 To 30</p>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="input">
                                                            <input type="text"
                                                                class="form-control"
                                                                id="DunningMessage_31_60"
                                                                name="DunningMessage_31_60"
                                                                value={mainStatementModal.DunningMessage_31_60}
                                                                onChange={handleStatementChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row m-0 pt-2 pb-3">
                                            <div className="col-md-6">
                                                <div className="d-flex gap-3 align-items-center">
                                                    <div className="col-md-2">
                                                        <p className="text">61 To 30</p>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="input">
                                                            <input type="text"
                                                                class="form-control"
                                                                id="DunningMessage_61_90"
                                                                name="DunningMessage_61_90"
                                                                value={mainStatementModal.DunningMessage_61_90}
                                                                onChange={handleStatementChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="d-flex align-items-center">
                                                    <div className="col-md-2">
                                                        <p className="text">Over 90</p>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="input">
                                                            <input type="text"
                                                                class="form-control"
                                                                id="DunningMessage_Over90"
                                                                name="DunningMessage_Over90"
                                                                value={mainStatementModal.DunningMessage_Over90}
                                                                onChange={handleStatementChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row m-0 app_border dunning_message">
                                            <p className="heading">Move to Collection Management</p>
                                        </div>
                                        <div className="row m-0 align-items-center py-3">
                                            <div className="col-md-4">
                                                <p className="text">
                                                    a) No. of days after sending the First Patient Statement
                                                </p>
                                            </div>
                                            <div className="col-md-1">
                                                <div className="input">
                                                    <input type="text"
                                                        class="form-control"
                                                        id="DaysAfterFirstStatement"
                                                        name="DaysAfterFirstStatement"
                                                        value={mainStatementModal.DaysAfterFirstStatement}
                                                        onChange={handleStatementChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row m-0 align-items-center pb-3">
                                            <div className="col-md-4">
                                                <p className="text">
                                                    b) No. of Patient Statements sent
                                                </p>
                                            </div>
                                            <div className="col-md-1">
                                                <div className="input">
                                                    <input type="text"
                                                        class="form-control"
                                                        id="NumberOfPatientStatementsSent"
                                                        name="NumberOfPatientStatementsSent"
                                                        value={mainStatementModal.NumberOfPatientStatementsSent}
                                                        onChange={handleStatementChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='btns-group text-end px-3  d-flex align-items-center justify-content-end pb-2'>
                                            <button className={IsEditAllowed ? "btn btn-orange" : "btn btn-orange disabled"} onClick={handleSaveStatement}>Save</button>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="StatementHistory">
                                        <div className='row mx-0 align-items-end py-2'>
                                            <div className='col-md-3'>
                                                <CalendaRangeInput searchParam={searchParamStatement} setSearchParam={setSearchParamStatement} options={['Statement']} />
                                            </div>
                                            <div className='col-md-3'>
                                                <div class="input">
                                                    <label for=""> Statement#</label>
                                                    <input
                                                        variant="outlined"
                                                        class="rounded form-control"
                                                        name="AddressLine1"
                                                        id="AddressLine1"
                                                        maxlength="55"
                                                        value={searchParam.StatementNo}
                                                        onChange={(e) => setSearchParamStatement(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className="btns-group-flex claims_btns">
                                                    <button className="btn btn-orange btn-xs no-width rounded" onClick={handleSearchStatementHistory}>Search</button>
                                                    <span class="seprate"></span>
                                                    <button className="btn btn-outline btn-xs no-width rounded me-1">Clear</button>
                                                    {/* <span class="seprate"></span> */}
                                                    {/* <button className="btn btn-info btn-xs no-width rounded me-1" onClick={handleDownloadexexl}>Export</button> */}
                                                </div>
                                            </div>
                                        </div>
                                        {/* Patient Statemtent History Table  */}
                                        <div className='row mx-0 align-items-end pt-2'>
                                            <div className="hk-docFlex__content col-md-12 px-0 ">
                                                <div className="row hk-docFlex__content__flex m-0">
                                                    <div className="doc-table col-md-12 px-0 doc_list ">
                                                        {/* {isLoading ? <Loader /> : null} */}
                                                        <Table
                                                            columns={Historycolumns}
                                                            rows={historyData}
                                                            height='265px'
                                                            dynamicClass='fill-grid DataGrid-Table hk-exp-table templates serviceline-grid pat-payment-grid blue-header'
                                                            rowHeight={25}
                                                            hidePagination={true}
                                                            Key={21}
                                                            Name={'PatientSearch'}
                                                            hideColClass={'hide'}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </div>
                    </div>
                </div>
            </div>
            {addCard}
        </>
    )
}

export default PatientPaymentsPat

function DetailedGrid({ isCellSelected, parentId, row }) {
    useEffect(() => {
        if (!isCellSelected)
            return;
    }, [isCellSelected]);

    const rowCount = SubGridDataFilter[row.parentId]?.length || 0;

    const rowClass = rowCount <= 4 ? `row-${rowCount}` : "";
    return (
        <>
            {
                Object.keys(SubGridDataFilter)?.length > 0 ?
                    <ReactDataGrid
                        key={SubGridDataFilter || SubGridData}
                        rows={(Object.keys(SubGridDataFilter)?.length > 0 && !isNull(SubGridDataFilter[row?.parentId])) ? SubGridDataFilter[row?.parentId] : []}
                        columns={PaymentDetailColumns}
                        rowHeight={25}
                        style={{ height: SubGridDataFilter.length > 3 ? '' : SubGridDataFilter.length * 52 + 'px' }}
                        className={`popper-detailed-table claim_inner_grid ar_subgrid_design  ${rowClass}`}
                    />
                    : null
            }
        </>
    );
}
